import { TYPE } from '@/theme';
import CloseIcon from '@mui/icons-material/Close';
import Backdrop from '@mui/material/Backdrop';
import Modal from '@mui/material/Modal';
import Zoom from '@mui/material/Zoom';
import cx from 'classnames';
import React from 'react';
import styled from 'styled-components';

const ModalWrapper = styled(Modal)`
    display: flex;
    align-items: center;
    justify-content: center;
`;

const Content = styled.div`
    position: relative;
    min-width: 480px;
    max-width: 800px;
    padding: 40px 38px;
    outline: none;
    box-sizing: border-box;
    padding-top: 0;

    background: #fff;
    border-radius: 24px;
    max-height: 96vh;
    overflow-y: scroll;
    ::-webkit-scrollbar {
        width: 0;
    }
    ${({ theme }) => theme.mediaWidth.upToSmall`
    width: calc(100vw - 2rem);
    min-width:80vw;
    max-width: calc(100vw - 2rem);
    padding: 1.5rem;
    padding-top: 0;
    `}
`;
const TitleWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-top: 30px;
    height: fit-content;
    z-index: 1;

    &.hasTitle {
        justify-content: space-between;
    }

    cursor: pointer;
    width: 100%;

    /* background-color: rgba(0, 0, 0, 0.1); */

    .closeIcon {
        width: 30px;
        height: 30px;
    }
`;

export interface Props {
    id?: string;
    isOpen?: boolean;
    onClose?(): void;
    children?: React.ReactNode;
    customContentClass?: string;
    hideClose?: boolean;
    disableBackgroundClick?: boolean;
    keepMounted?: boolean;
    className?: string;
    title?: string;
}

export default function TransitionsModal({
    id,
    isOpen,
    onClose,
    children,
    customContentClass,
    hideClose,
    keepMounted,
    disableBackgroundClick = false,
    className,
    title,
}: Props) {
    return (
        <ModalWrapper
            id={id}
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            className={cx(className)}
            open={!!isOpen}
            onClose={disableBackgroundClick ? undefined : onClose}
            closeAfterTransition
            BackdropComponent={Backdrop}
            keepMounted={keepMounted}
            BackdropProps={{
                timeout: 500,
                onClick: disableBackgroundClick ? () => {} : undefined,
            }}
        >
            <Zoom in={isOpen}>
                <Content className={cx('modalContent', customContentClass)}>
                    {!hideClose && (
                        <TitleWrapper
                            onClick={onClose}
                            className={!!title ? 'hasTitle' : ''}
                        >
                            {title && (
                                <TYPE.main
                                    fontSize={24}
                                    mobileFz={18}
                                    fontWeight={600}
                                >
                                    {title}
                                </TYPE.main>
                            )}
                            <CloseIcon className="closeIcon" />
                        </TitleWrapper>
                    )}
                    {children}
                </Content>
            </Zoom>
        </ModalWrapper>
    );
}
